<script>
import moment from 'moment';
// import Layout from '@layouts/main'
import { AxiosHelper } from '@src/utils/utils'


export default {
  components: { },
  props: {
    // chinaWord: {
    //   type: Object,
    //   required: false,
    //   default: () => ({}),
    // },
    // autoSpeak: {
    //   type: Boolean,
    //   required: false,
    //   default: false,
    // },
  },
  data() {
    return {
			optionList : [],
			cardInfos : '0|현금',
			dt : moment().format('YYYY.MM.DD HH:mm'),
			// dt : moment(this.props.time).format('YYYY.MM.DD HH:mm'),
			price : 0,
			place : ''
    }
  },
  created() {
		AxiosHelper.get('/api/cardsms/cardInfo/list').then(ret => {
			this.optionList = ret.data;
		});
	},
  mounted() {},
  methods: {
    show: function(time) {
	    let m = moment(time);
	    m.set('hour', moment().hour())
	    m.set('minute', moment().minute())
			this.dt = m.format('YYYY.MM.DD HH:mm');
			this.price = 0;
			this.place = '';

      this.$refs.modal.show()
		},
		
		cashRegist() {
			if(this.dt === '') {
				alert("사용일시가 누락됨.");
				return;
			}

			if(this.price === '') {
				alert("사용금액이 누락됨.");
				return;
			}

			if(this.place === '') {
				alert("사용내역이 누락됨.");
				return;
			}

			AxiosHelper.post('/api/cardsms/pay/history/manualRegist', {
				cardInfos : this.cardInfos,
				dt : this.dt,
				price : this.price,
				place : this.place
			}).then(ret => {
				this.pushMessage('등록완료');
				
				this.hidden({
					action : 'added',
					dt : this.dt,
					card_name : this.cardInfos.split('|')[1],
					price : this.price
				});
			});
		},

    hidden(obj) {
			this.$refs.modal.hide()
      this.$emit('hidden', obj);
    },
  },
}
</script>

<template>
  <C.Modal
    ref="modal"
    title="수기 결제 입력"
    dialog-class-name="modal-dialog-scrollable modal-md"
    @hidden="hidden"
  >
    <template v-slot:buttons>
      <button type="button" class="btn btn-primary" @click="cashRegist">등록</button>,
    </template>

		<div class="form-group row">
			<label class="col-4 col-form-label">지불방법</label>
			<div class="col-7">
				<select v-model="cardInfos" class="form-control" >
					<option v-for="item in optionList" :key="item.phone" :value="item.phone + '|' + item.card_name">{{item.card_name}}</option>
				</select>
			</div>
		</div>
		<div class="form-group row">
			<label class="col-4 col-form-label">지출일시</label>
			<div class="col-7">
				<C.CalendarInput
					v-model="dt"
				/>
			</div>
		</div>
		<div class="form-group row">
			<label class="col-4 col-form-label">지출금액
				</label>
			<div class="col-7">
				<input v-model="price" type="number" class="form-control"/>
			</div>
		</div>

		<div class="form-group row">
			<label class="col-4 col-form-label">지출내역</label>
			<div class="col-7">
				<input v-model="place" type="text" class="form-control"/>
			</div>
		</div>
  </C.Modal>
</template>
